export { getTracker, setTrackerConfig } from './utils/initTracker';
export { trackPageViewActions, trackEventActions } from './utils/trackerEvents';
export { default as TrackAnalytics } from './analytics';